<template>
    <div class="vipt">
        <!-- <div class="screen">
            <el-cascader v-model="value" :options="options" placeholder="订单类型:" @change="handleChange" />
        </div> -->
        <div class="screen">
            <el-cascader v-model="value" :options="options2" placeholder="类型筛选:" @change="handleChange2" />
        </div>
        <div class="search">
            <div style="width: 24px;height: 24px;">
                <img style="width: 100%;height: 100%;" src="../assets/secree.png" alt="">

            </div>
            <div>
                <input type="text" placeholder="关键字搜索" v-model="keyword" @keyup.enter="seach">
            </div>
        </div>
        <div class="calendar">
            <el-date-picker class="choosedatas" v-model="choosedata" type="daterange" range-separator="-"
                start-placeholder="" end-placeholder="" @change="changedata" format="MM.DD" :clearable="true" />
        </div>
        <div class="exdown" @click="openDialog">
            <img src="../assets/goodlist/xdown.png" alt="">&nbsp; 下载
        </div>
    </div>
    <div class="vipporpe" v-loading="loading">
        <table>
            <thead>
                <tr>
                    <th style="width: 50px;">
                        <!-- <el-checkbox /> -->
                    </th>
                    <th style="width: 100px;">订单</th>
                    <th style="width: 150px;">日期</th>
                    <th style="width: 180px;">买家</th>
                    <th style="width: 160px;">卖家</th>
                    <!-- <th style="width: 200px;">支付状态</th>
                    <th style="width: 200px;">交易状态</th> -->
                    <th style="width: 100px;">价格</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(item, index) in StoreDatalist" :key="index"
                    style="cursor: pointer;">
                    <td @click.stop>
                        <el-checkbox v-model="item.chooses" @change="choosexid(item.order.id, item.chooses)" />
                    </td>
                    <td>
                        <div class="stroeh">
                            <!-- <div class="header">
                                <img :src="images(item.productInfo.ppreviewpic)" alt="">
                            </div> -->
                            <div class="storename">
                                <div
                                    style="overflow:hidden;text-overflow:ellipsis;display:-webkit-box;-webkit-box-orient:vertical;-webkit-line-clamp:2;">
                                    {{ item.productName }}</div>
                                <div class="stid">ID: {{ item.orderId }}</div>
                            </div>
                        </div>
                    </td>
                    <td>
                        {{ datahuan(item.enrollTime) }}
                    </td>
                    <td>
                        <div style="line-height: 25px;width: 180px;"> {{ item.userName  }}
                            <br>
                            门铃号: {{ item.userId }}
                        </div>

                    </td>
                    <td>
                        <div style="color: #718096;width: 250px;line-height: 25px;">
                            {{ item.storeName || '未知商家' }} <br>
                            店铺ID：{{ item.storeId || "未知店铺ID" }}
                        </div>
                    </td>
                    <!-- <td @click="gomessage(item)">
                        <div class="statea">
                            {{ orderStates(item.order.orderState) }}
                        </div>

                    </td>
                    <td>
                        <div class="statea">
                            {{ orderState(item.order.orderState) || '未知' }}
                        </div>
                    </td> -->
                    <td style="color: #718096;">
                        ￥{{ item.productAmount }}
                      
                    </td>
                </tr>
            </tbody>
        </table>
        <div style=" height: 70px;"></div>

    </div>
    <div class="pagechoose" >

        显示结果：

        <div class="pagees">

            <input v-model="pageSize" type="number" min="1" max="99" @keyup.enter="pageSizechange">

        </div>

    </div>
    <Noshu :disabled="loading" :lengths="StoreDatalist.length" ></Noshu>
   
    <div v-if="keyseache.length >= 1">
        <el-pagination :disabled="loading" class="example-pagination-iskey" background v-model:current-page="current"
            layout="prev, pager, next" :pager-count="5" :page-count="9999999" @current-change="changepige" />
    </div>
    <div class="example-pagination-block" v-else>
        <el-pagination :disabled="loading" background v-model:current-page="current" layout="prev, pager, next"
            :pager-count="5" :total="total" @current-change="changepige" />
    </div>
    <yc-mask ref="maskRef" :close-on-click-modal="false">
        <div class="dialog">
            <div class="dialogt">
                <div>
                    导出属性
                </div>
                <div @click="closeDialog">
                    <el-icon>
                        <Close />
                    </el-icon>
                </div>
            </div>
            <div class="exchooses">
                <div class="exchoosee" v-for="(item, index) in exports" :key="index">
                    <div>{{ item.name }}</div>
                    <div>
                        <el-switch v-model="item.chooses" @change="changeex(item.experts, item.chooses)" />
                    </div>
                </div>

            </div>
            <div class="downex">
                <div class="dowm" @click="productExport">
                    下载excel
                </div>
            </div>
        </div>
    </yc-mask>
</template>

<script setup>

import { ref, reactive, onMounted } from 'vue'
import { useRouter } from 'vue-router';
import storeapi from '@/api/store'
import { useStore } from 'vuex';
import Noshu from '@/components/Noshu.vue'
const store = useStore()
const emit = defineEmits(['totallist'])
let loading = ref(false)
let current = ref(1)
let keyword = ref('')
let startDate = ref('')
let endDate = ref('')
let StoreDatalist = ref([])
let orderStatus = ref(null)
let total = ref(100)
let keywordType = ref(1)
let pageSize = ref(5)

onMounted(() => {
    storelist()
})
const pageSizechange = () => {
    if (pageSize.value <= 1) {
        pageSize.value = 1
    }
    if (pageSize.value >= 99) {
        pageSize.value = 99
    }
    console.log('pageSize', pageSize.value)
    storelist()
}
const storelist = async () => {
    loading.value = true
    try {
        let data
        if (keyword.value.length > 1) {
            data = {

                "endDate": endDate.value,
                "keyword": keyword.value,
                'keywordType': keywordType.value,
                "page": {
                    "current": current.value,
                    "pageSize": pageSize.value
                },
                "startDate": startDate.value
            }
        } else {
            data = {
                "startDate": startDate.value,
                "endDate": endDate.value,
                "page": {
                    "current": current.value,
                    "pageSize": pageSize.value
                }
            }
        }

        const res = await storeapi.pageFreebuy(data)
        if (res.success) {
            StoreDatalist.value = res.data.records
            console.log('交易订单', StoreDatalist.value)
            emit('totallist', res.data.total)
            total.value = (Math.ceil(res.data.total / pageSize.value))
            console.log('total.value', total.value)
            for (let index = 0; index < res.data.records.length; index++) {
                res.data.records[index].chooses = false
            }
            loading.value = false
        } else {

        }

    } catch (error) {
        // 处理错误
        console.log(error)
    }
}

const images = (face) => {

    if (face) {
        const regex = /"(.*?)"/;
        const result = face.match(regex);
        // 输出提取的字符
        if (result && result[1]) {
            if (result[1].startsWith('http')) {
                return result[1]
            } else {
                if (result[1].startsWith('/')) {
                    return 'http://www.daomenkou.cn' + result[1]

                } else {
                    return 'http://www.daomenkou.cn/' + result[1]

                }
            }
        } else {
            console.log('未找到匹配的字符串');

            if (face.startsWith('http')) {
                return face
            } else {
                return 'http://www.daomenkou.cn/' + face
            }
        }
    } else {
        return require('../assets/shop/morentx.png')
    }

}

//跳转页面
const changepige = (val) => {
    console.log(val)
    current.val = val
    storelist()
}
//搜索
let keyseache = ref('')
const seach = () => {
    startDate.value = ''
    endDate.value = ''
    current.value = 1
    keyseache.value = keyword.value

    storelist()
}

const router = useRouter()
const gomessage = (storeId) => {
    console.log(storeId.order)
    // sessionStorage.setItem('order',storeId)
    store.commit('setStoreId', storeId)
    router.push({
        path: '/home/orderlist/orderdetail',
    })
}
const value = ref([])
const value2 = ref(5)
const colors = ref(['#FF2928', '#FF2928', '#FF2928'])
const options = reactive([
    {
        value: '',
        label: '全部订单',
    },
    {
        value: '0',
        label: '已取消',
    },
    {
        value: '10',
        label: '未付款',
    },
    {
        value: '20',
        label: '待发货',
    },
    {
        value: '30',
        label: '待收货',
    },
    {
        value: '40',
        label: '待评论'
    }
])
const options2 = reactive([
    {
        value: '1',
        label: '用户',
    },
    {
        value: '2',
        label: '店铺',
    },
 
])
const orderState = (State) => {

    if (State == '0') {
        return '已取消'
    } else if (State == '10') {
        return '未付款'
    } else if (State == '20') {
        return '待发货'
    } else if (State == '30') {
        return '已发货'
    } else if (State == '40') {
        return '已收货'
    }
}
const orderStates = (State) => {
    if (State == '10' || State == '0') {
        return '未付款'
    } else if (State == '20' || State == '30' || State == '40') {
        return '已付款'
    } else {
        return '未知'

    }
}
const handleChange = (value) => {
    console.log(value)
    orderStatus.value = value[0]
    current.value = 1
    storelist()

}
const handleChange2 = (value) => {
    console.log(value)
    keywordType.value = value[0]
    // storelist()

}
let nowdata = new Date()
let nextdata = new Date()
const choosedata = ref([nowdata, nextdata])
const changedata = (e) => {
    if (e == null) {
        e = ['', '']
    }

    console.log(e)
    startDate.value = datahuan2(e[0])
    endDate.value = datahuan2(e[1])
    console.log(startDate.value)
    console.log(endDate.value)
    storelist()
}
const datahuan2 = (days) => {
    if (days) {
        const date = new Date(days);
        const year = date.getFullYear();
        const month = (date.getMonth() + 1).toString().padStart(2, '0'); // 补零
        const day = date.getDate().toString().padStart(2, '0'); // 补零
        return `${year}-${month}-${day}`;
    } else {
        return ''
    }

}
const datahuan = (days) => {
    const date = new Date(days)
    const year = date.getFullYear()
    const month = date.getMonth() + 1
    const day = date.getDate()
    return `${year}.${month}.${day}`
}

//导出
import ycMask from '@/components/mask/mask.vue'
//相关变量
let exports = ref([])
let chooseex = ref([])
let pids = ref([])
let screenType = ref('0')
let endTime = ref('')
let startTime = ref('')


//关闭弹窗
let closeDialog = () => {
    maskRef.value.closeMask();
};
//获取遮罩的实例
let maskRef = ref(null);
//导出的遮罩层
let openDialog = async () => {
    const res = await storeapi.exportEntityType('ORDER')
    console.log(res)
    let values = Object.values(res.data.filedExplain);
    for (let a = 0; a < values.length; a++) {
        let parts = values[a].split("_");
        let data = {
            chooses: false,
            name: parts[0],
            experts: parts[1]
        }
        exports._rawValue.push(data)
    }
    console.log(exports)
    maskRef.value.showMask();
};
//筛选表头
const changeex = (experts, chooses) => {
    console.log(experts, chooses)
    if (chooses) {
        chooseex._rawValue.push(experts)
    } else {
        let index = chooseex._rawValue.indexOf(experts);
        chooseex._rawValue.splice(index, 1)
    }
    console.log(chooseex._rawValue)
}
//筛选条数
const choosexid = (pid, choose) => {
    console.log(pid, choose)
    if (choose) {
        pids._rawValue.push(pid)
    } else {
        let index = pids._rawValue.indexOf(pid);
        pids._rawValue.splice(index, 1)
    }
    console.log(pids._rawValue)
}
//下载
const productExport = async () => {
    // let a = pids._rawValue.join(",");
    // let b = chooseex._rawValue.join(",");
    //  console.log(a, b)


    let data = {
        "exportEntityType": "ORDER",
        // "exportDataCount": 200,
        "exportFiledList": chooseex._rawValue,
        "exportIdList": pids._rawValue,
    }

    // let data = {
    //     productType: 1,
    //     // endTime: endTime.value, 
    //     productListId: pids._rawValue,
    //     screenListFiled: chooseex._rawValue,
    //     // startTime: startTime.value,
    //     // wordKey: choosekey.value
    // }

    console.log(data)

    let res = await storeapi.exportData2File(data)
    console.log(res)
    // window.URL.createObjectURL(res)
    let blob = new Blob([res], { type: "application/vnd.ms-excel" });
    // console.log(blob)

    let url = window.URL.createObjectURL(blob);
    // console.log(url)

    let link = document.createElement('a');
    // console.log(link)

    link.download = "product.xls";
    link.href = url;
    link.click();

}
</script>

<style lang="scss" scoped>
::v-deep .choosedatas {
    width: 100%;
    height: 100%;
    background-color: #FAFAFA;
    --el-input-border-color: transparent;
    cursor: pointer;



    input {
        font-size: 16px;
        color: #718096;
        cursor: pointer;
    }

}

::v-deep .example-pagination-iskey {
    position: absolute;
    bottom: 15px;
    right: 34px;

    .number,
    .btn-quicknext,
    .is-last,
    .is-first {
        background-color: transparent !important;
    }

    .el-pager {
        display: none !important;
    }

    .is-active {
        background-color: #EBF3FF !important;
        color: #1787FF !important;
        border-radius: 8px;
    }
}

::v-deep .el-input {
    width: 168px;
    height: 48px;
    font-size: 16px;
    --el-input-text-color: #718096;
    --el-input-border-color: transparent;

    .el-input__wrapper {
        background: #FAFAFA !important;

        .el-icon {
            width: 26px;
            height: 26px;

            svg {
                width: 26px;
                height: 26px;
            }
        }
    }

    ::placeholder {
        font-weight: 400;
        font-size: 14px;
        color: #718096;
    }
}

.pagechoose {
    position: absolute;
    bottom: 0px;
    left: 14px;
    width: 100%;
    height: 70px;
    padding-left: 20px;
    box-sizing: border-box;
    display: flex;
    align-items: center;

    .pagees {
        width: 71px;
        height: 40px;
        border: 1px solid #EEEFF2;
        border-radius: 8px;
        padding: 8px 0 0 0px;
        box-sizing: border-box;

        input {
            width: 80%;


        }
    }
}



::v-deep .el-checkbox__input {
    height: 20px;

    .el-checkbox__inner {
        width: 20px;
        height: 20px;
        border-radius: 10px;
    }

    .el-checkbox__inner {
        &::after {
            top: 4px;
            left: 8px;
        }

    }
}


.vipt {
    padding-top: 9px;
    margin-left: 15px;
    display: flex;

    .screen {
        width: 168px;
        height: 48px;
        background: #F8F8F8;
        border-radius: 8px;
        margin-right: 24px;
    }

    .search {
        width: 412px;
        height: 48px;
        margin-right: 24px;
        background: #FAFAFA;
        box-shadow: 0px 6px 58px 0px rgba(196, 203, 214, 0.1);
        border-radius: 8px;
        display: flex;
        align-items: center;
        padding-left: 20px;
        box-sizing: border-box;

        input {
            width: 300px;
            border: none;
            outline: none;
            font-size: 16px;
            background: #FAFAFA;

        }

        ::placeholder {
            font-weight: 400;
            font-size: 14px;
            color: #7D8592;
        }

    }

    .calendar {
        width: 168px;
        height: 48px;
        background: #FAFAFA;
        border-radius: 8px;
    }

    .exdown {
        width: 101px;
        height: 48px;
        background: #FAFAFA;
        border-radius: 8px;
        margin-left: 31px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-weight: 400;
        font-size: 14px;
        color: #718096;
        cursor: pointer;


        img {
            width: 17px;
            height: 21px;
        }
    }

}

.vipporpe {
    width: 100%;
    // padding-left: 15px;
    box-sizing: border-box;





    table {
        width: 100%;
        border-collapse: collapse;
        border-spacing: 0;

        thead {
            text-align: left;
            font-size: 14px;
            font-weight: 400;
            color: #4D585F;
            border-bottom: 1px solid #EEEFF2;
            height: 46px;

            th {
                vertical-align: middle;

            }

            th:first-child {
                padding-left: 15px;
            }

            .states {
                text-align: center;
            }
        }

        tbody {
            tr {
                height: 96px;
                font-size: 14px;
                font-weight: 400;
                color: #000000;
                border-bottom: 1px solid #EEEFF2;

                td:first-child {
                    padding-left: 15px;
                }

                td:nth-child(2) {
                    padding-right: 30px;
                    width: 350px;

                    .stroeh {
                        display: flex;

                        .header {
                            width: 56px;
                            height: 56px;

                            border-radius: 8px;
                            margin-right: 24px;

                            img {
                                width: 100%;
                                height: 100%;
                            }
                        }

                        .storename {
                            height: 60px;
                            font-size: 16px;

                            font-weight: 400;
                            color: #111827;
                            display: flex;
                            flex-direction: column;
                            justify-content: space-around;

                            .stid {
                                font-size: 14px;
                                font-family: HelveticaNeue;
                                color: #718096;
                            }
                        }

                    }
                }

                td:last-child {

                    color: #1787FF;

                }

                td {

                    vertical-align: middle;

                    .statea {
                        width: 66px;
                        height: 42px;
                        background: #EBF3FF;
                        border-radius: 4px;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        font-size: 14px;
                        font-weight: 400;
                        color: #1787FF;
                        cursor: pointer;
                    }


                }


            }

            tr:hover {
                background-color: #f3f3f3;
            }
        }

    }
}

.dialog {
    position: relative;
    width: 500px;
    height: 608px;
    background: #FFFFFF;
    border-radius: 8px;
    overflow: hidden;

    .dialogt {
        display: flex;
        justify-content: space-between;
        align-items: center;
        font-size: 18px;
        font-weight: 600;
        color: rgba(0, 0, 0, 0.88);
        margin-bottom: 20px;
        padding: 23px 36px 0 35px;
    }

    .exchooses {
        padding: 23px 36px 0 35px;
        height: 400px;
        overflow: auto;

        .exchoosee {
            display: flex;
            height: 38px;
            justify-content: space-between;
            font-size: 14px;
            font-weight: 400;
            color: #111827;
            align-items: center;
            margin-top: 13px;
        }
    }

    .downex {
        .dowm {
            width: 121px;
            height: 51px;
            background: #3686FF;
            border-radius: 8px;
            text-align: center;
            line-height: 51px;
            font-size: 17px;
            font-family: PingFangSC, PingFang SC;
            font-weight: 400;
            color: #FFFFFF;
        }

        display: flex;
        align-items: center;
        justify-content: center;
        width: 500px;
        height: 120px;
        background: #F2F8FC;

    }

}
</style>